import type {
  AddLocationAddressType,
  AddLocationLocationType,
} from "@/Shared/Types/locationTypes";
import type { Address } from "@freightsimple/generated-dashboard-openapi-client/models/Address";
import type { Location } from "@freightsimple/generated-dashboard-openapi-client/models/Location";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { formatPostalCode } from "@/Helpers/formatPostalCode";

export function formatAddress(address: Address | AddLocationAddressType) {
  if (address.postalCode === undefined) {
    throw new Error("Missing postalCode");
  }
  return `${address.city}, ${address.stateOrProvinceCode}, ${formatPostalCode(
    address.postalCode,
  )}`;
}

export function quotesFormatLocation(
  location: Location | AddLocationLocationType | PreQuoteLocation,
) {
  return formatAddress(location.address);
}
